import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./componenets/Home";
import Security from "./componenets/Security";
import Portal from "./pages/Portal/portal";
import LoginPage from "./pages/Login/LoginPage";
import { ErrorProvider } from "./contexts/ErrorContext";
import PageNotFound from "./componenets/pageNotFound";

const App: React.FC = () => {
  return (
    <ErrorProvider>
      <Router>
        <Home>
          <Routes>
            {/* Public Route */}
            <Route path="/login" element={<LoginPage />} />

            {/* Protected Routes */}
            <Route element={<Security />}>
              <Route path="/" element={<Portal />} />
            </Route>

            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </Home>
      </Router>
    </ErrorProvider>
  );
};

export default App;
